import { render, staticRenderFns } from "./ManageStaffLeavesEntitlements.vue?vue&type=template&id=e81a94a6&scoped=true&"
import script from "./ManageStaffLeavesEntitlements.vue?vue&type=script&lang=js&"
export * from "./ManageStaffLeavesEntitlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81a94a6",
  null
  
)

export default component.exports